var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4853 10.1107L16.1836 8.03218M17.9937 10.1588L19.5745 6.3501",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.265 18.3892C19.4565 18.1248 18.7445 17.8725 18.0084 17.7884C14.0986 17.3439 13.5918 21.2847 17.755 21.2727C21.7975 21.2727 21.4234 25.2016 17.5016 24.757C16.7776 24.6729 16.0535 24.4206 15.2571 24.1563M17.7429 25.0694V26.8116M17.7429 15.7339V17.476",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0728 9.69353L20.136 9.65582C20.6292 8.72554 22.1847 7.01583 22.6273 5.64555C24.0942 1.15757 16.102 5.25584 11.5115 4.31299C11.0689 4.22499 13.6107 7.15412 14.6983 9.7061M14.6097 10.1335H20.3889C22.3111 10.1335 25.0553 12.3461 27.3063 14.9986C30.5689 18.8203 34.3754 28.1609 28.2168 31.2283C26.0543 32.3094 22.6652 32.058 17.7965 32.058C12.6117 32.058 9.22257 32.2717 7.13598 31.1151C1.50853 27.9849 4.78383 18.5563 7.99591 14.7346C10.1078 12.2204 12.6876 10.1335 14.6224 10.1335H14.6097Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundedIcon);
export default __webpack_public_path__ + "static/media/fundedIcon.ca74d5bcf8cb93819b0c0fe60cbb81a1.svg";
export { ForwardRef as ReactComponent };